<template>
  <div>
    <new-user-dialog v-model="isNewUserDialogOpened" :client="client" @created="userCreated" />
    <user-dialog v-model="isUserDialogOpened" :client="client" />
    <v-row no-gutters align="center" class="content-header">
      <span class="font-weight-bold">Utilisateurs</span>
      <v-spacer></v-spacer>
      <v-btn :disabled="!$canWrite" dark color="primary" elevation="0" @click="$canWrite && (isNewUserDialogOpened = true)">
        <v-icon left>add</v-icon>
        Nouvel utilisateur
      </v-btn>
    </v-row>
    <v-col class="py-2 search-bar border-component">
      <v-text-field
        v-model="searchString"
        placeholder="Rechercher un utilisateur..."
        prepend-icon="search"
        hide-details
        dense
        clearable
        class="input-no-b-line"
      ></v-text-field>
    </v-col>
    <v-col class="pa-0 pt-4" v-if="client.isRoot && company.id === client.id">
      <v-alert dense text outlined type="info" class="ma-0">
        Les utilisateurs créés sur cette page auront donc accès à l'ensemble de vos clients et interventions.<br>
        Pour créer un utilisateur d'un client, veuillez vous rendre sur la page du client puis sur l'onglet "Utilisateurs".
      </v-alert>
    </v-col>
    <v-col class="pa-0 pt-4">
      <v-list class="pa-0 border-component relative">
        <v-row no-gutters justify="center" align="center" class="py-8" style="min-height: 100px;" v-if="isFetchingUsers">
          <v-progress-linear
            color="primary"
            indeterminate
            rounded
            height="6"
            class="absolute-progress"
          ></v-progress-linear>
        </v-row>
        <v-row no-gutters justify="center" align="center" class="pa-4 text--secondary" style="min-height: 100px;" v-else-if="!users.length">
          Aucun utilisateur
        </v-row>
        <template v-for="(user, index) in users">
          <v-list-item
            :key="`user-${index}`"
            @click="openUserDialog(user)"
          >
            <v-list-item-avatar>
              <v-icon :color="user.color">account_circle</v-icon>
            </v-list-item-avatar>

            <v-row no-gutters>
              <v-col align="left">
                <v-list-item-content>
                  <v-list-item-title>{{ user.lastname }} {{ user.firstname }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <span v-if="user.username">{{ user.username }} ({{ user.email || `aucun email` }})</span>
                    <span v-else>{{ user.email }} </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-col>
              <div class="mt-3">
                <v-chip small color="orange lighten-1" text-color="white" class="mr-3" v-if="user.invitationStatus !== 2">En attente</v-chip>
                <v-chip small color="success darken-1" text-color="white" v-if="user.role === `administrator`">Administrateur</v-chip>
                <v-chip small color="primary darken-1" text-color="white" v-else-if="user.role === `contributor`">Contributeur</v-chip>
                <v-chip small color="light-blue" text-color="white" v-else>Lecteur</v-chip>
              </div>
            </v-row>
          </v-list-item>
          <v-divider
            v-if="index + 1 < users.length"
            :key="index"
          ></v-divider>
        </template>
      </v-list>
    </v-col>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import NewUserDialog from '@/components/NewUserDialog.vue';
import UserDialog from '@/components/UserDialog.vue';

export default {
  props: [`client`],
  data: () => ({
    isFetchingUsers: false,
    isNewUserDialogOpened: false,
    isUserDialogOpened: false,
    isKeepingStateOnDestroy: false,
  }),
  computed: {
    ...mapState(`model/client`, [
      `company`,
    ]),
    ...mapState(`ui/usersList`, {
      storeSearchString: `searchString`,
    }),
    searchString: {
      get() {
        return this.storeSearchString;
      },
      set(searchString) {
        this.setSearchString(searchString);
      },
    },
    ...mapState(`model/user`, {
      storeUsers: state => _
        .orderBy(state.users, [`lastname`, `firstname`])
        .map(user => ({
          ...user,
          searchString: _.lowerCase(`${user.firstname} ${user.lastname} || ${user.lastname} ${user.firstname}`),
        })),
    }),
    users() {
      let users = this.storeUsers;
      if (this.searchString) {
        const searchString = _.lowerCase(this.searchString);
        users = _.filter(users, user =>
          user.searchString.indexOf(searchString) !== -1
        );
      }
      return users;
    },
  },
  methods: {
    openUserDialog(user) {
      this.$store.dispatch(`model/user/setCurrentUser`, user);
      this.isUserDialogOpened = true;
    },
    setSearchString(searchString) {
      this.$store.commit(`ui/usersList/SET_SEARCH_STRING`, searchString);
    },
    async userCreated({ id }) { // eslint-disable-line
      this.$store.dispatch(`showSnackbar`, {
        color: `success`,
        message: `Utilisateur créé avec succès`,
      });
      // const user = _.find(this.users, { id });
      // this.openUserDialog(user);
    },
  },
  async beforeMount() {
    this.isFetchingUsers = true;
    this.$store.commit(`model/user/SET_USERS`, []);
    await this.$store.dispatch(`model/user/fetchUsers`, this.client.id);
    this.isFetchingUsers = false;
  },
  destroyed() {
    this.setSearchString(``);
  },
  components: {
    NewUserDialog,
    UserDialog,
  },
};
</script>
